import React, { useMemo } from "react";
import { AppPage, MimaButton, MimaTable, PageLoader } from "../../components";
import styles from "../../assets/styles/BusinessCategory/BusinessCategory.module.scss";
import {
  AddNewCategoryContainer,
  DeleteCategoryContainer,
  EditCategoryContainer,
} from "../../containers";
import { AnimatePresence } from "framer-motion";
import MimaOptionMenu from "../../components/OptionMenu/";
import { useState } from "react";
import constant from "../../utils/constant";

const BusinessCategory = ({
  deleteCategoryModal,
  goToDeleteCategoryModal,
  goToAddCategoryModal,
  addCategoryModal,
  closeModal,
  goToEditCategoryModal,
  editCategoryModal,
  isLoading,
  bizCategorydata,
  isFetching,
  limit,
  onLimitChange,
  currentPage,
  setCurrentPage,
  setSearchQuery,
}) => {
  const [data, setData] = useState({});

  const tableData = useMemo(() => {
    if (bizCategorydata?.status === constant.Success) {
      return bizCategorydata?.data?.bizCategories || [];
    }
    return [];
  }, [bizCategorydata]);

  const tableColumns = [
    {
      Header: "Business Name",
      accessor: "name",
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <MimaOptionMenu
            options={[
              {
                label: "Edit",
                value: "EDIT",
              },
              {
                label: "Delete",
                value: "DELETE",
              },
            ]}
            onOptionSelected={(option) => {
              setData(item);
              if (option.value === "EDIT") {
                goToEditCategoryModal();
              } else if (option.value === "DELETE") {
                goToDeleteCategoryModal();
              }
            }}
          />
        );
      },
    },
  ];

  return (
    <AppPage pageTitle="Business Category">
      <>
        <MimaButton
          title="Add New Category"
          width={30}
          onClick={goToAddCategoryModal}
          mt={5}
          mb={5}
        />
        <MimaTable
          tableData={tableData}
          tableColumns={tableColumns}
          searchPlaceholder="Search Subscription"
          searchVariant="wide"
          totalItems={data?.data?.totalCounts}
          onLimitChange={onLimitChange}
          isLoading={isLoading}
          isFetching={isFetching}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchQuery={setSearchQuery}
        />
        {(addCategoryModal || editCategoryModal || deleteCategoryModal) && (
          <di className="modal">
            <AnimatePresence>
              {addCategoryModal && (
                <AddNewCategoryContainer closeModal={closeModal} data={data} />
              )}
              {editCategoryModal && (
                <EditCategoryContainer closeModal={closeModal} data={data} />
              )}
              {deleteCategoryModal && (
                <DeleteCategoryContainer closeModal={closeModal} data={data} />
              )}
            </AnimatePresence>
          </di>
        )}
      </>
    </AppPage>
  );
};
export default BusinessCategory;
